/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export function Icon6Icon(props) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      version={"1.1"}
      viewBox={"0 0 1024 1024"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "m857.81 497.36-90.94-90.94-219.52-219.51c-19.53-19.53-51.19-19.53-70.71 0L257.12 406.42l-90.93 90.94a50.02 50.02 0 0 0-14.64 35.35v289.74c0 27.62 22.39 50 50 50h620.9c27.61 0 50-22.38 50-50V532.71c0-13.26-5.27-25.98-14.64-35.35M512 768c-86.13 0-162.32-42.54-208.73-107.75l61.97-44.01C397.86 662.09 451.44 692 512 692s114.14-29.91 146.76-75.76l61.97 44.01C674.32 725.46 598.13 768 512 768"
        }
      ></path>
    </svg>
  );
}

export default Icon6Icon;
/* prettier-ignore-end */
